import { Template } from "@/types/templates";

export const QUERY_TEMPLATES: Array<Template> = [
  {
    templateId: "confirm-expense-nature",
    title: "Kindly confirm expense nature.",
    subjectText: "Kindly confirm expense nature.",
    bodyText:
      "Hi, \n\nCould you please confirm the nature of the following expense:\n\nDate: [Date]\nAmount: [Amount]\nDescription: [Current Description]\nThis information will help ensure accurate categorisation in our accounting records.\n\nPlease log into Jack to reply.\n\nThanks so much,\n{creator}",
    tags: ["expense", "general"],
    active: true
  },
  {
    templateId: "confirm-expense-nature-vat",
    title: "Kindly confirm expense nature and VAT treatment.",
    subjectText: "Kindly confirm expense nature and VAT treatment.",
    bodyText:
      "Hi, \n\nCould you please confirm the nature and VAT treatment of the following expense:\n\nDate: [Date]\nAmount: [Amount]\nDescription: [Current Description]\n\nPlease log into Jack to reply.\n\nThanks so much,\n{creator}",
    tags: ["expense"],
    active: true
  },
  {
    templateId: "confirm-income-nature",
    title: "Kindly confirm income nature.",
    subjectText: "Kindly confirm income nature.",
    bodyText:
      "Hi, \n\nCould you please confirm the nature of the following income:\n\nDate: [Date]\nAmount: [Amount]\nSource/Description: [Current Description]\n\nPlease log into Jack to reply.\n\nThanks so much,\n{creator}",
    tags: ["income"],
    active: true
  },
  {
    templateId: "confirm-income-nature-vat",
    title: "Kindly confirm income nature and VAT treatment.",
    subjectText: "Kindly confirm income nature and VAT treatment.",
    bodyText:
      "Hi, \n\nCould you please confirm the nature and VAT treatment ((VATable, exempt, outside scope, etc.) of the following income:\nDate: [Date]\nAmount: [Amount]\nSource/Description: [Current Description]\n\nPlease log into Jack to reply.\n\nThanks so much,\n{creator}",
    tags: ["income"],
    active: true
  },
  {
    templateId: "income-relates-to-invoice",
    title: "Which invoice does this income relate to?",
    subjectText: "Which invoice does this income relate to?",
    bodyText:
      "Hi, \n\nCould you please identify which invoice the following income relates to:\n\nDate Received: [Date]\nAmount: [Amount]\nReference: [Bank Reference/Description]\n\nIf you could provide the invoice number and date, it would be most helpful for our records.\n\nPlease log into Jack to reply.\n\nThanks so much,\n{creator}",
    tags: ["income", "recon"],
    active: true
  },
  {
    templateId: "refund-relates-to-which-transaction",
    title: "Which transaction does this refund relate to?",
    subjectText: "Which transaction does this refund relate to?",
    bodyText:
      "Hi, \n\nI am reviewing our accounts and need clarification regarding a recent refund entry.\n\nCould you please confirm which original transaction the following refund relates to:\n\nDate: [Date]\nAmount: [Amount]\nDescription: [Current Description]\n\nPlease provide details of the original transaction including date, amount, and reference number if available.\n\nPlease log into Jack to reply.\n\nThanks so much,\n{creator}",
    tags: ["refund", "recon"],
    active: true
  },
  {
    templateId: "confirm-sales-income",
    title: "Kindly confirm if this is sales income?",
    subjectText: "Kindly confirm if this is sales income?",
    bodyText:
      "Hi, \n\nCould you please confirm if the following is sales income?\n\nDate: [Date]\nAmount: [Amount]\nDescription: [Current Description]\n\nPlease log into Jack to reply.\n\nThanks so much,\n{creator}",
    tags: ["income"],
    active: true
  },
  {
    templateId: "provide-supporting-paperwork",
    title: "Please provide additional supporting paperwork.",
    subjectText: "Please provide additional supporting paperwork.",
    bodyText:
      "Hi, \n\nYou have a missing document(s) request.\n\nHere are the details:\n\n[StatementDetailsList]\n\nPlease log into Jack and upload documents or you can send them in via your normal channels as well.\n\nThanks so much,\n{creator}",
    tags: ["chaser", "general"],
    active: true
  },
  {
    templateId: "bill-payment-statement",
    title:
      "Please provide the bill payment statement covering all payments made.",
    subjectText:
      "Please provide the bill payment statement covering all payments made.",
    bodyText:
      "Hi, \n\nCould you please provide the bill payment statement covering all payments made for the period: xx.\n\nPlease log into Jack to upload or use your normal channels, just as email forwarding or Whatsapp.\n\nThanks so much,\n{creator}",
    tags: ["chaser", "general"],
    active: true
  },
  {
    templateId: "invoice-received-statement",
    title:
      "Please provide the invoice received statement covering all payments received.",
    subjectText:
      "Please provide the invoice received statement covering all payments received.",
    bodyText:
      "Hi, \n\nCould you please provide the invoice received statement covering all payments received for the period: xx.\n\nPlease log into Jack to upload or use your normal channels, just as email forwarding or Whatsapp.\n\nThanks so much,\n{creator}",
    tags: ["chaser", "general"],
    active: true
  }
];

export const TEMPLATE_TITLE_TO_SUMMARY: Record<
  string,
  { title: string; description: string }
> = {
  "Kindly confirm expense nature.": {
    title: "Expense clarification",
    description:
      "Ask client to clarify a single expense so it can be categorised correctly."
  },
  "Kindly confirm expense nature and VAT treatment.": {
    title: "Expense VAT check",
    description: "Confirm how to treat VAT on a specific expense."
  },
  "Kindly confirm income nature.": {
    title: "Income clarification",
    description:
      "Clarify the nature of an income entry for correct classification."
  },
  "Kindly confirm income nature and VAT treatment.": {
    title: "Income VAT check",
    description: "Confirm VAT treatment for a specific income entry."
  },
  "Which invoice does this income relate to?": {
    title: "Income invoice match",
    description: "Match received payment to its corresponding sales invoice."
  },
  "Which transaction does this refund relate to?": {
    title: "Refund matching",
    description:
      "Link a refund to its original transaction for a clean audit trail."
  },
  "Kindly confirm if this is sales income?": {
    title: "Sales income ID",
    description: "Identify/label sales income correctly."
  },
  "Please provide additional supporting paperwork.": {
    title: "Transaction paperwork request",
    description: "Ask client to upload supporting documents for a transaction."
  },
  "Please provide the bill payment statement covering all payments made.": {
    title: "Bank statement request",
    description: "Request a bill payment statement for a given period."
  },
  "Please provide the invoice received statement covering all payments received.":
    {
      title: "Duplicate template",
      description: "Placeholder/duplicate entry to be resolved."
    }
};

export const getAllTemplates = (): Array<Template> => QUERY_TEMPLATES;

export const getTemplatesByTags = (tags?: Array<string>): Array<Template> => {
  if (!tags || tags.length === 0) return QUERY_TEMPLATES;
  const tagSet = new Set(tags.map((t) => t.toLowerCase()));
  return QUERY_TEMPLATES.filter((t) =>
    (t.tags || []).some((x) => tagSet.has(x.toLowerCase()))
  );
};

export const getQuerySummary = (title: string) =>
  TEMPLATE_TITLE_TO_SUMMARY[title];
